import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DefaultError } from '../../common/utils/error';
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
var defaultConfig = {
  serviceUrl: "".concat(DEFAULT_CONFIG.stargateRoot, "/users/manage")
};
var NOT_EDITABLE = 'not_editable';
var NOT_EDITABLE_FIELD = 'field';
var NOT_EDITABLE_REASON = 'reason';
export var MutabilityClient = /*#__PURE__*/function (_RestClient) {
  _inherits(MutabilityClient, _RestClient);
  var _super = _createSuper(MutabilityClient);
  function MutabilityClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, MutabilityClient);
    return _super.call(this, _objectSpread(_objectSpread({}, defaultConfig), config));
  }
  _createClass(MutabilityClient, [{
    key: "getProfileWithMutability",
    value: function () {
      var _getProfileWithMutability = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.getResource("/".concat(userId, "/profile")).then(function (resp) {
                return mapToMutabilityConstraints(resp);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProfileWithMutability(_x) {
        return _getProfileWithMutability.apply(this, arguments);
      }
      return getProfileWithMutability;
    }()
  }]);
  return MutabilityClient;
}(RestClient);
function mapToMutabilityConstraints(json) {
  var constraints = [];
  if (json[NOT_EDITABLE] != null) {
    var _iterator = _createForOfIteratorHelper(json[NOT_EDITABLE]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        constraints = constraints.concat({
          field: value[NOT_EDITABLE_FIELD],
          reason: determineReason(value[NOT_EDITABLE_REASON])
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return constraints;
}
function determineReason(value) {
  switch (value) {
    case 'managed':
    case 'ext.dir.scim':
    case 'ext.dir.google':
      return value;
    default:
      throw new DefaultError({
        message: "Unknown mutability constraint reason: ".concat(value)
      });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new MutabilityClient();